import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../../constants/translation';

class TotalAmountModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
  }

  static getPropsToState = (props) => {
    const open = props.open;
    return {
      open,
    };
  }

  constructor(props) {
    super(props);
    const state = TotalAmountModal.getPropsToState(props);
    this.state = {
      ...state,
    };
  }

  componentWillReceiveProps(nextProps) {
    const state = TotalAmountModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }

  handleOnClose = () => {
    this.props.onClose();
  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        centered
        open={this.state.open}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="small"
      >
        <Modal.Content centered>
          <p>
            <Trans
              ns={TRANSLATION_FILES.screens}
              i18nKey="booking_fee_description" // Explicit key to avoid index matching bugs
              components={{ bold: <strong /> }}
            >
              <bold>Total amount of booking fee</bold> is the amount that a Purchaser needs to pay to reserve a unit.
              </Trans>
          </p>

          <p>
            <Trans
              ns={TRANSLATION_FILES.screens}
              i18nKey="new_payment_description" // Explicit key to avoid index matching bugs
              components={{ bold: <strong /> }}
            >
              <bold>New Payment</bold> button is to create a payment transaction. MHub allows multiple payment transactions.
              </Trans>
          </p>
        </Modal.Content>
      </Modal>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(TotalAmountModal);



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/TotalAmountModal.jsx